'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _bluebird = require('bluebird');

var _bluebird2 = _interopRequireDefault(_bluebird);

var _redial = require('redial');

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import Progress from 'react-progress-2';
var currentTransitionNo = 0;

var RedialTransitOnFetch = function (_React$Component) {
  (0, _inherits3.default)(RedialTransitOnFetch, _React$Component);

  function RedialTransitOnFetch() {
    (0, _classCallCheck3.default)(this, RedialTransitOnFetch);
    return (0, _possibleConstructorReturn3.default)(this, (RedialTransitOnFetch.__proto__ || (0, _getPrototypeOf2.default)(RedialTransitOnFetch)).apply(this, arguments));
  }

  (0, _createClass3.default)(RedialTransitOnFetch, [{
    key: 'componentWillMount',
    value: function componentWillMount() {
      var _props = this.props,
          renderProps = _props.renderProps,
          locals = _props.locals;


      this.setState({
        renderProps: renderProps
      });

      (0, _redial.trigger)('defer', renderProps.components, locals);
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this2 = this;

      var renderProps = nextProps.renderProps,
          locals = nextProps.locals;

      var thisTransitionNo = ++currentTransitionNo;

      var fetch = (0, _redial.trigger)('fetch', renderProps.components, locals).then(function () {
        if (currentTransitionNo == thisTransitionNo) {
          _this2.setState({ renderProps: renderProps });
        }
      });

      var defer = (0, _redial.trigger)('defer', renderProps.components, locals);

      /* const waiting = setTimeout(Progress.show, 100);*/
      /* BPromise.all([ fetch, defer ]).then(() => {*/
      /* Progress.hide();*/
      /* clearTimeout(waiting);*/
      /* });*/
    }
  }, {
    key: 'render',
    value: function render() {
      var renderProps = this.state.renderProps;


      return _react2.default.createElement(_reactRouter.RouterContext, renderProps);
    }
  }]);
  return RedialTransitOnFetch;
}(_react2.default.Component);

exports.default = RedialTransitOnFetch;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/utils/RedialTransitOnFetch.jsx
// module id = 2349
// module chunks = 0